import { PublicClientApplication } from "@azure/msal-browser";

const msalConfig = {
  auth: {
    clientId: "b739cdc1-f297-4cd6-860a-246cd2e500db",
    authority: "https://login.microsoftonline.com/4d7bdb03-e5d4-4c8f-b463-f849b32a7b9c",
    // redirectUri: "http://localhost:3000",
    // redirectUri : "https://idedemo.digitalglyde.com"
    // redirectUri : "https://ideportalwebapp.azurewebsites.net"
    redirectUri : "https://ideportal.digitalglyde.com"
  },
  cache: {
    cacheLocation: "localStorage", // or sessionStorage
    storeAuthStateInCookie: false,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);
